export default "__VITE_ASSET__sb6QVjpn__"